import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import {
  getWorkspaceBillingAlert,
  type WorkspaceBillingAlertData,
} from "../helpers/get-workspace-billing-alert";

export function useWorkspaceBillingAlert(
  workspaceId: string | undefined,
  enabled = true,
) {
  const query = useQuery({
    queryKey: ["billing", workspaceId],
    enabled: Boolean(workspaceId) && enabled,
    queryFn: () =>
      api<WorkspaceBillingAlertData>(`/${workspaceId}/billing`),
  });

  return getWorkspaceBillingAlert(query.data);
}
